if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        if (this.querySelector("form")) {
          this.form = this.querySelector("form");
          this.form.querySelector("[name=id]").disabled = false;
          this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        } else {
          this.querySelector("[name=id]").disabled = false;
          this.querySelector("button[type=submit]").addEventListener(
            "click",
            this.onSubmitHandler.bind(this)
          );
        }

        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner")?.classList.remove(
          "hidden"
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (!this.form) {
          formData.append("id", this.querySelector("[name=id]").value);
        }

        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        let addSucceeded = false;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            // CART ERROR EVENT
            if (response.status) {
              document.dispatchEvent(
                new CustomEvent("cart:error", {
                  detail: {
                    source: this.dataset.source,
                    productVariantId: formData.get("id"),
                    errors: response.description,
                    message: response.message,
                  },
                })
              );
              // -------------------------------------------
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              const refresh = Number(response.status) === 422
                ? this.refreshCartAfterError()
                : undefined;
              if (!soldOutMessage) return refresh;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return refresh;
            }
            addSucceeded = true;
            if (!this.cart) {
              this.redirectToCart();
              return;
            }

            // VARIANT ADDED EVENT
            document.dispatchEvent(
              new CustomEvent("variant:add", {
                detail: {
                  variant: {
                    id: formData.get("id"),
                  },
                  quantity: Number(formData.get("quantity") || 1),
                  formElement: this.form,
                  sectionId: this.dataset.source,
                },
              })
            );
            // -------------------------------------------

            fetch(`${routes.cart_url}.js`)
              .then((response) => {
                return response.text();
              })
              .then((state) => {
                const parsedState = JSON.parse(state);

                // dispatch cart:change for the entire basket
                document.dispatchEvent(
                  new CustomEvent("cart:change", {
                    detail: {
                      cart: parsedState,
                      sectionId: this.dataset.source,
                    },
                  })
                );
                // dispatch cart:change for the entire basket
              })
              .catch((error) => {
                console.error("Error fetching cart state:", error);
              });

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
              });
            this.error = false;
            const renderCart = () => {
              try {
                this.cart.renderContents(response);
                this.cart.classList.remove("is-empty");
              } catch (error) {
                console.error(error);
                this.redirectToCart();
              }
            };
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(renderCart);
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              renderCart();
            }
          })
          .catch((e) => {
            if (addSucceeded) {
              console.error(e);
              this.redirectToCart();
              return;
            }
            const message =
              "Nu am putut adăuga produsul. Verifică conexiunea și încearcă din nou.";
            console.error(e);
            this.handleErrorMessage(message);
            document.dispatchEvent(
              new CustomEvent("cart:error", {
                detail: {
                  source: this.dataset.source,
                  productVariantId: formData.get("id"),
                  errors: message,
                  message,
                },
              })
            );
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (!this.error && !this.redirectingToCart) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner")?.classList.add(
              "hidden"
            );
          });
      }

      redirectToCart() {
        this.redirectingToCart = true;
        this.submitButton.setAttribute("aria-disabled", true);
        window.location = routes.cart_url;
      }

      async refreshCartAfterError() {
        if (!this.cart) return;
        try {
          const sections = this.cart.getSectionsToRender();
          const response = await fetch(`${routes.cart_url}?sections=${sections.map((section) => section.id).join(",")}`);
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          const rendered = await response.json();
          const updates = sections.map((section) => {
            const html = new DOMParser().parseFromString(rendered[section.id] || "", "text/html");
            const source = html.querySelector(section.selector || ".shopify-section");
            const target = section.selector
              ? document.querySelector(section.selector)
              : document.getElementById(section.id);
            if (!source || !target) throw new Error("Missing cart section after error");
            return { source, target, drawer: html.querySelector("cart-drawer") };
          });
          updates.forEach(({ source, target, drawer }) => {
            target.innerHTML = source.innerHTML;
            if (drawer) this.cart.classList.toggle("is-empty", drawer.classList.contains("is-empty"));
          });
          this.cart.querySelector("#CartDrawer-Overlay")?.addEventListener("click", () => this.cart.close());
        } catch (error) {
          console.error(error);
          this.redirectToCart();
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
